/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import datePicker from '@bingads-webui-component-legacy/datepicker/binding/datePicker';
import template from '@bingads-webui-campaign-legacy/adextension-shared/template/scheduling.pug';
import ViewModel from '@bingads-webui-campaign-legacy/adextension-shared/viewmodel/scheduling';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextension/shared');
function parseDate(value) {
  var dateValue = _.isDate(value) ? value : _.isEmpty(value) ? null : new Date(value);
  if (dateValue && isNaN(dateValue.getTime())) {
    dateValue = null;
  }
  return dateValue;
}
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = _.extend({}, options);
    this.ko_model = new ViewModel(this.options.model);
    if (typeof this.options.onDayTimeRangesChange === 'function') {
      this.ko_model.dayTimeRanges.subscribe(this.options.onDayTimeRangesChange);
    }
  },
  render: function () {
    var self = this;
    var date = new Date();
    self.$el.html(template({
      i18n: i18n,
      labelClass: self.options.labelClass || 'col-sm-4',
      controlClass: self.options.controlClass || 'col-sm-8',
      hideStartAndEndDate: self.options.hideStartAndEndDate,
      readOnly: this.options.readOnly
    }));
    ko.applyBindings(self.ko_model, self.el);
    var endDatePicker = self.$('input.date-end').data('kendoDatePicker');
    self.ko_model.startDate.subscribe(function (startDate) {
      var parsedDate = parseDate(startDate);
    });
    self.$('#scheduling').on('show.bs.collapse', function () {
      self.$('.expanderImage').toggleClass('expanderImage expandedImage');
    });
    self.$('#scheduling').on('hide.bs.collapse', function () {
      self.$('.expandedImage').toggleClass('expanderImage expandedImage');
    });
    if (typeof self.options.onDayTimeRangesChange === 'function') {
      self.options.onDayTimeRangesChange(self.ko_model.dayTimeRanges());
    }
    return self;
  },
  events: {
    'click .add-time-row': 'addDayTimeRange',
    'show.bs.collapse': 'show',
    'hide.bs.collapse': 'hide'
  },
  addDayTimeRange: function () {
    return this.ko_model.addDayTimeRange();
  },
  toObject: function () {
    return this.ko_model.toObject();
  },
  validate: function () {
    return this.ko_model.validate();
  },
  show: function () {
    this.ko_model.isExpanded(true);
  },
  hide: function () {
    this.ko_model.isExpanded(false);
  },
  modelChanged: function () {
    return this.ko_model.modelChanged();
  }
});
export default View;

